import React from "react";
import { Route } from "react-router-dom";

import { injectDriftChatNonLoggedIn } from "./methods";

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => injectDriftChatNonLoggedIn(Component, props)}
  />
);

export default PublicRoute;



// WEBPACK FOOTER //
// ./src/app/PublicRoute.js